export default [
    {
        path: '/brands',
        name: 'Brands',
        component: () => import(/* webpackChunkName: 'brand' */ './views/Index.vue')
    }
]
